import { defineStore } from 'pinia'
import { PlaybackStore } from './playback_store.js'
import { PlayerStore } from './player_store.js'
import { ClickStore } from './click_store.js'
import { VideoStore } from './video_store.js'
import { doAction } from '@/front/composables/ClickComposer.js'
import { highlightBox, focusAndHighlight } from '@/front/composables/UxComposer';

import dayjs from 'dayjs'


export const LeadCaptureStore = defineStore('leadCapture', {
  state: () => ({
    shown: false, // Track if lead capture has been shown to prevent multiple shows
    fields: [],
    pendingAnn: null,
    config: {
      type: null,  // 'start', 'timestamp', 'first_click', 'specific_interaction'
      timestamp: null,
      interactionId: null
    }
  }),

  actions: {
    finishCapture() {
      const playbackStore = PlaybackStore()
      const videoStore = VideoStore()
      log.info(3,"💟 LeadCaptureStore finishCapture", this.fields)

      let valid = true
      // Validate required fields
      this.fields.forEach(field => {
        if (valid && (field.required && videoStore.video.captureRequired) && !playbackStore.variables[field.name.toUpperCase()]) {
          log.info(3,"💟 LeadCaptureStore finishCapture required field not filled", field.label)
          field.type == 'checkbox' ? highlightBox('lead-capture-field-' + field.name, 10, 2000) : focusAndHighlight('lead-capture-field-' + field.name, 10, 2000,true)
          valid = false
        }

        if (field.label.toLowerCase() == "email") {
          let email = playbackStore.variables[field.name.toUpperCase()]
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          let isValidEmail = emailRegex.test(email)
          if (email && !isValidEmail) {
            log.info(3,"💟 LeadCaptureStore finishCapture invalid email", field.label)
            focusAndHighlight('lead-capture-field-' + field.name, 10, 2000,true)
            valid = false
          }
        } else if (field.label.toLowerCase() == "phone") {
          let phone = playbackStore.variables[field.name.toUpperCase()]
          // Same as in StringValidator.js
          const regex = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{2,4}\)?[-.\s]?)?\d{3,4}[-.\s]?\d{3,9}$/;
          let isValidPhone = regex.test(phone)
          if (phone && !isValidPhone) {
            log.info(3,"💟 LeadCaptureStore finishCapture invalid phone", field.label)
            focusAndHighlight('lead-capture-field-' + field.name, 10, 2000,true)
            valid = false
          }
        }

        // Format date, TOOD better way?
        if (field.type == 'date') {
          playbackStore.setVariable(field.name.toUpperCase(), dayjs(playbackStore.variables[field.name.toUpperCase()]).format('MM/DD/YY'))
        } else {
          playbackStore.setVariable(field.name.toUpperCase(), playbackStore.variables[field.name.toUpperCase()])
        }
      })

      if (!valid) {
        return
      }

      this.shown = true
      const clickStore = ClickStore()
      clickStore.stopLeadCapture()
      if (this.pendingAnn) {
        doAction(this.pendingAnn)
        this.pendingAnn = null
      }
      const playerStore = PlayerStore()
      playerStore.resetVolume()
    },
    setConfig(video) {
      this.fields = []
      const playbackStore = PlaybackStore()
      log.info(2,"💟 LeadCaptureStore setConfig", video, this.shown)

      if (video.captureName) { this.fields.push({label: 'name', name: 'name', type: 'text', format: 'text', variable: 'name', value: playbackStore.getVariable('name'), required: false})}
      if (video.captureEmail) { this.fields.push({label: 'email', name: 'email', type: 'text', format: 'email', variable: 'email', value: playbackStore.getVariable('email'), required: false})}
      if (video.capturePhone) { this.fields.push({label: 'phone', name: 'phone', type: 'text', format: 'phone', variable: 'phone', value: playbackStore.getVariable('phone'), required: false})}
      if (video.captureID) { this.fields.push({label: 'custom_id', name: 'custom_id', type: 'text', format: 'text', variable: 'custom_id', value: playbackStore.getVariable('custom_id'), required: false})}

      if (video.captureCustomFields) {
        video.captureCustomFields.forEach(field => {
          if (this.fields.filter(f => f.name === field.name).length == 0) {
            this.fields.push({
              label: field.label,
              name: field.name,
              type: field.type,
              format: field.format,
              options: field.options || [],
              variable: field.name,
              value: playbackStore.getVariable(field.name),
              required: false
            })
          }
        })
      }

      this.fields.forEach(field => {
        if (video.requiredCaptureFields.includes(field.label)) {
          field.required = true
        }
        // log.info(3,"💟 LeadCaptureStore:", field.label, field.type, field.required, field.value)
      })
      // Don't show if no fields
      if (this.fields.length == 0) {
        this.shown = true
        return
      }

      let needsCapture = 0
      this.fields.forEach(field => {
       if (!field.value) {
        needsCapture++
       }
      })
      log.info(3,"💟 LeadCaptureStore setConfig fields", this.fields)
      log.info(3,"💟 LeadCaptureStore setConfig needsCapture", needsCapture)
      if (needsCapture == 0) {
        this.shown = true
        return
      }

      // Set config based on video settings
      // log.info(3,"💟 LeadCaptureStore setConfig video.capture_auth_point", video.capture_auth_point)
      switch (video.capture_auth_point) {
        case -1:
          // log.info(3,"💟 LeadCaptureStore setConfig dont_capture")
          this.shown = true
          break
        case 0:
          // log.info(3,"💟 LeadCaptureStore setConfig start")
          this.config.type = 'start'
          break
        case 1:
          // log.info(3,"💟 LeadCaptureStore setConfig first_interaction")
          this.config.type = 'first_interaction'
          break
        case 2:
          // log.info(3,"💟 LeadCaptureStore setConfig timestamp", video.lead_capture_time)
          this.config.type = 'timestamp'
          this.config.timestamp = Number(video.capture_auth_value)  
          break
        case 3:
          // log.info(3,"💟 LeadCaptureStore setConfig interaction", video.capture_auth_value)
          this.config.type = 'specific_interaction'
          this.config.interactionId = video.capture_auth_value
          break
      }
      log.info(3,"💟 LeadCaptureStore setConfig", this.config)
      this.shown = false
    },

    checkTriggers(currentTime) {
      if (this.shown) return false // Don't show more than once
      
      const playbackStore = PlaybackStore()
      const videoStore = VideoStore()
      if (videoStore.video.manage) {
        return false
      }

      switch (this.config.type) {
        case 'start':
          if (currentTime < 0.5 && !playbackStore.leadCaptured) { // Show in first half second
            log.info(3,"💟 LeadCaptureStore checkTriggers start", currentTime)
            this.showLeadCapture()
          } else {
            return false
          }
          break

        case 'timestamp':
          log.info(3,"💟 LeadCaptureStore checkTriggers timestamp", currentTime, this.config.timestamp, currentTime >= this.config.timestamp)
          if (currentTime == this.config.timestamp && !playbackStore.leadCaptured) {
            this.showLeadCapture()
          } else {
            return false
          }
          break
      }
      return false
    },

    handleInteractionClick(interaction) {
      let id = interaction.id
      log.info(3,"💟 LeadCaptureStore handleInteractionClick", interaction.force_lead_capture)
      if (interaction.force_lead_capture) {
        this.showLeadCapture()
        return
      }
      if (this.shown) return

      if (this.config.type === 'first_interaction' || 
        (this.config.type === 'specific_interaction' && 
         this.config.interactionId === id)) {
        this.showLeadCapture()
      }
    },

    showLeadCapture() {
      const clickStore = ClickStore()
      this.shown = true
      clickStore.startLeadCapture() // Assume this exists to show the dialog
    }
  }
})

// // In your AnnStore, add to updateActive:
// updateActive(time) {
//   const leadCaptureStore = LeadCaptureStore()
//   leadCaptureStore.checkTriggers(time)
  
//   // Rest of your existing updateActive code...
// }

// // In your ClickComposer, add to clickInteraction:
// function clickInteraction(ann) {
//   const leadCaptureStore = LeadCaptureStore()
//   leadCaptureStore.handleInteractionClick(ann.id)
  
//   // Rest of your existing clickInteraction code...
// }
